import React from "react";

/**
 * Our Story hero — Stitch our-story.html + mobile screenshot (390-wide).
 */
const Herosection = () => {
  return (
    <section
      className="relative pt-12 pb-20 sm:pt-16 sm:pb-24 md:pt-24 md:pb-32 overflow-hidden text-left"
      style={{
        backgroundColor:
          "color-mix(in srgb, var(--color-cloud-mist) 40%, var(--color-white))",
      }}
    >
      <div
        className="absolute -top-12 -right-12 w-64 sm:w-96 h-64 sm:h-96 rounded-full blur-3xl pointer-events-none"
        style={{
          backgroundColor:
            "color-mix(in srgb, var(--color-cloud-mist) 60%, transparent)",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute bottom-0 left-1/4 w-56 sm:w-80 h-56 sm:h-80 rounded-full blur-2xl pointer-events-none"
        style={{
          backgroundColor:
            "color-mix(in srgb, var(--color-cloud-mist) 40%, transparent)",
        }}
        aria-hidden="true"
      />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 relative z-10 pb-6 sm:pb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-3.5 rounded-full bg-surface-white border border-hairline mb-5 sm:mb-6 shadow-sm max-w-full">
          <svg
            fill="none"
            height="18"
            stroke="currentColor"
            className="text-heart-teal shrink-0"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            width="18"
            aria-hidden="true"
          >
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
          </svg>
          <span className="text-spectrum-blue font-headline text-xs font-semibold tracking-wide">
            Our Mission & Heart
          </span>
        </div>

        <h1 className="font-headline text-[1.75rem] leading-tight sm:text-4xl lg:text-5xl tracking-tight max-w-3xl mb-5 sm:mb-6 text-ink">
          <span className="font-light block sm:inline">Every Journey</span>
          <span className="font-extrabold text-spectrum-blue"> Has a Beginning</span>
        </h1>

        <p className="font-body text-[15px] sm:text-base md:text-lg text-muted max-w-2xl leading-relaxed mb-6 sm:mb-8">
          When one mother&apos;s search for support became a mission to connect
          thousands of families navigating neurodiversity.
        </p>

        <div className="flex items-start sm:items-center gap-2.5 sm:gap-3 flex-wrap">
          <svg
            fill="none"
            height="24"
            width="34"
            viewBox="0 0 34 24"
            className="text-heart-teal shrink-0 mt-0.5 sm:mt-0"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            aria-hidden="true"
          >
            <path d="M2 20C10 20 18 14 26 4" />
            <path d="M11 16C10 13 12 11 15 12" />
            <path d="M18 12C19 9 22 9 23 11" />
            <path d="M25 6C27 4 30 5 30 7" />
          </svg>
          <span className="font-accent-hand text-[20px] sm:text-[22px] leading-snug text-heart-teal">
            Rooted in shared love, authentic community
          </span>
        </div>
      </div>

      {/* White organic wave into next section — Stitch path */}
      <div
        className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none pointer-events-none"
        aria-hidden="true"
      >
        <svg
          className="w-full block h-12 sm:h-14 md:h-16"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 1440 68"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 40C320 72 720 10 1080 38C1240 50 1360 20 1440 32V68H0V40Z"
            fill="var(--color-white)"
          />
        </svg>
      </div>
    </section>
  );
};

export default Herosection;
